import React, { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { TabViewTabChangeEvent } from 'primereact/tabview';
import { useStores } from 'stores/hooks/hooks';
import Loading from 'components/UI/Loading/Loading';
import { TabPanel, TabView } from 'components/UI/TabView';
import PlotsSensorsTable from './PlotsSensorsTable';
import PlotActionsTable from './PlotActionsTable';
import PlotDetails from './PlotDetails';

const Container = styled.div`
  width: 100%;
  height: 100%;

  .p-tabview-panels {
    height: 100%;
  }

  .p-tabview-nav {
    margin: 0.5rem 1rem;
  }
`;

const StyledTabView = styled(TabView)`
  height: 100%;
  .p-tabview-nav {
    margin: 0.5rem 1rem;
  }
`;

enum TabKey {
  Details = 0,
  Sensors = 1,
  Actions = 2,
}

const PlotSensors: FC = observer(() => {
  const { t } = useTranslation('grower');
  const [tabIndex, setTabIndex] = useState(TabKey.Sensors);
  const { resellersStore, actionsStore } = useStores();
  const isLoading = resellersStore.growerSensors.loading;
  const [actionsLoading, setActionsLoading] = useState(true);

  const onTabChange = useCallback(({ index }: TabViewTabChangeEvent) => {
    setTabIndex(index);
  }, []);

  const loadActions = useCallback(async () => {
    setActionsLoading(true);
    await actionsStore.getActions(resellersStore.selectedGrowerId || 0);
    setActionsLoading(false);
  }, [actionsStore, resellersStore.selectedGrowerId]);

  useEffect(() => {
    loadActions();
  }, [loadActions]);

  return (
    <Container>
      <StyledTabView
        activeIndex={tabIndex}
        renderActiveOnly
        onTabChange={onTabChange}
      >
        <TabPanel header={t('details')}>
          <PlotDetails />
        </TabPanel>
        <TabPanel header={t('sensors')}>
          {isLoading ? <Loading /> : <PlotsSensorsTable />}
        </TabPanel>
        <TabPanel header={t('actions')}>
          {actionsLoading ? <Loading /> : <PlotActionsTable />}
        </TabPanel>
      </StyledTabView>
    </Container>
  );
});

export default PlotSensors;
